import PropTypes from 'prop-types'
import React from 'react'

import { DefaultTable } from 'twyne-new.ui'

const propTypes = {
  data: PropTypes.array,
}

const ReportsProgressionTable = ({ data }) => {
  const columns = [
    {
      dataField: 'path_name',
      text: 'Path',
    }, {
      dataField: 'name',
      text: 'Page',
    }, {
      dataField: 'failures',
      text: 'Failures',
    },
  ]

  return <DefaultTable data={data} columns={columns} />
}

ReportsProgressionTable.propTypes = propTypes

export default ReportsProgressionTable
